//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { CreatorNotesResponse } from '@apis/creator-notes/CreatorNotesApiModel';
import { isDefined } from '@utils/filterPredicates';
import { Serialized } from '@utils/types/Serialized';

export const deserializeCreatorNotes = (
  creatorNotes: Serialized<CreatorNotesResponse>,
): CreatorNotesResponse => ({
  ...creatorNotes,
  ...(isDefined(creatorNotes.createdAt)
    ? { createdAt: new Date(creatorNotes.createdAt) }
    : { createdAt: undefined }),
  ...(isDefined(creatorNotes.updatedAt)
    ? { updatedAt: new Date(creatorNotes.updatedAt) }
    : { updatedAt: undefined }),
});
